// Lo que se ve cuando no se puede pedir: la tienda no existe, no abrió, está cerrada o el número ya no tiene acceso.
import { Icono } from '@reparto/ui';
import { useState } from 'react';
import { Boton } from '../componentes/base';
import { Bienvenida } from '../componentes/Bienvenida';
import { cargarPerfil, salir, useCuenta } from '../datos/cuenta';
import { cargarMarca, useMarca } from '../datos/marca';
import { useSesion } from '../datos/sesion';

function Mensaje({ icono, titulo, texto }: { icono: string; titulo: string; texto: string }) {
  return (
    <div className="text-center">
      <span className="mx-auto grid h-20 w-20 place-items-center rounded-full bg-stone-200 text-stone-700">
        <Icono nombre={icono} tamano={40} />
      </span>
      <h2 className="mt-4 text-2xl font-bold">{titulo}</h2>
      <p className="mt-2 text-lg text-stone-700">{texto}</p>
    </div>
  );
}

function BotonSalir() {
  const hay = useSesion((s) => !!s.sesion);
  const [ocupado, setOcupado] = useState(false);
  if (!hay) return null;
  return (
    <Boton
      variante="secundario"
      bloque
      tamano="lg"
      icono="logout"
      cargando={ocupado}
      onClick={async () => {
        setOcupado(true);
        await salir();
        setOcupado(false);
      }}
    >
      Salir
    </Boton>
  );
}

function Reintentar({ onClick }: { onClick: () => Promise<void> }) {
  const [ocupado, setOcupado] = useState(false);
  return (
    <Boton
      bloque
      tamano="lg"
      icono="refresh"
      cargando={ocupado}
      onClick={async () => {
        setOcupado(true);
        await onClick();
        setOcupado(false);
      }}
    >
      Probar de nuevo
    </Boton>
  );
}

export function TiendaCerrada() {
  const marca = useMarca((s) => s.marca);
  return (
    <Bienvenida marca={marca} grande>
      <Mensaje
        icono="storefront"
        titulo="La tienda está cerrada por ahora"
        texto={`Por el momento no se pueden hacer pedidos a ${marca?.nombre ?? 'la distribuidora'} desde acá. Probá más tarde o hacé tu pedido como siempre.`}
      />
      <div className="mt-8 flex flex-col gap-3">
        <Reintentar onClick={cargarMarca} />
        <BotonSalir />
      </div>
    </Bienvenida>
  );
}

export function TiendaNoExiste() {
  return (
    <Bienvenida marca={null} lema="Pedidos a tu distribuidora" grande>
      <Mensaje
        icono="travel_explore"
        titulo="No encontramos esta tienda"
        texto="Revisá que la dirección esté bien escrita o abrí el enlace que te mandó tu distribuidora."
      />
    </Bienvenida>
  );
}

export function ErrorMarca() {
  const error = useMarca((s) => s.error);
  return (
    <Bienvenida marca={null} lema="Pedidos a tu distribuidora" grande>
      <Mensaje icono="signal_disconnected" titulo="No pudimos abrir la tienda" texto={error ?? 'Revisá tu conexión.'} />
      <div className="mt-8">
        <Reintentar onClick={cargarMarca} />
      </div>
    </Bienvenida>
  );
}

/** La cuenta o el número ya no tienen acceso (403 de la API) o no se pudo traer el perfil la primera vez. */
export function SinAcceso() {
  const marca = useMarca((s) => s.marca);
  const { estado, mensaje } = useCuenta();
  const bloqueado = estado === 'bloqueado';
  const conCuenta = useSesion((s) => !s.sesion?.telefono && !!s.sesion?.identidad_id);
  return (
    <Bienvenida marca={marca} grande>
      <Mensaje
        icono={bloqueado ? 'lock' : 'cloud_off'}
        titulo={
          bloqueado
            ? conCuenta
              ? 'No podés pedir con esta cuenta'
              : 'No podés pedir con este número'
            : 'No pudimos cargar tus datos'
        }
        texto={mensaje ?? 'Consultá con la distribuidora.'}
      />
      <div className="mt-8 flex flex-col gap-3">
        <Reintentar onClick={cargarPerfil} />
        <BotonSalir />
      </div>
    </Bienvenida>
  );
}
